/**
 * تنظیمات کلی اپلیکیشن
 */
export const APP_CONFIG = {
  name: 'پنل مدیریت جلسات',
  shortName: 'جلسات',
  version: '1.0.0',
  copyright: `© ${new Date().getFullYear()} تمامی حقوق محفوظ است`,
  direction: 'rtl',
  defaultLocale: 'fa',
  defaultTheme: 'light',
};

export const STORAGE_KEYS = {
  THEME: 'mp_theme',
  COLLAPSED: 'mp_sidebar_collapsed',
  AUTH_TOKEN: 'mp_auth_token',
  USER: 'mp_user',
  /** کش لیست سازمان‌ها برای نمایش فوری بعد از رفرش */
  ORGANIZATIONS: 'mp_organizations',
  /** آخرین سازمان فعال انتخاب‌شده (uuid) برای هم‌ترازی UI بعد از رفرش */
  CURRENT_ORG_ID: 'mp_current_org_id',
  /** توکن ادمین اصلی هنگام impersonation — برای بازگشت بدون ورود مجدد */
  ADMIN_AUTH_TOKEN: 'mp_admin_auth_token',
  /** پروفایل ادمین قبل از impersonation — حفظ فلگ‌های سوپرادمین پس از بازگشت */
  ADMIN_USER: 'mp_admin_user',
};
